import useGetApi from 'src/api/useGetApi';

export interface CustomerBasicInfo {
  customerId: string;
  name: string;
}

type ApiResponse = CustomerBasicInfo[];

const useCustomersByIds = (
  customerIds: string[] | undefined,
  enabled = true,
) => {
  return useGetApi<ApiResponse>({
    endpoint: 'accounts-receivable/customers-by-ids',
    queryParameters:
      customerIds && customerIds.length > 0 ? { ids: customerIds } : undefined,
    options: {
      enabled: enabled && customerIds && customerIds.length > 0,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  });
};

export default useCustomersByIds;
